export const DsInputBaseDefaultProps = {
    size: 'medium',
    autoComplete: 'off',
    type: 'text'
};
